import { render, staticRenderFns } from "./TeacherTrainingModules.vue?vue&type=template&id=9ca32454&scoped=true&"
import script from "./TeacherTrainingModules.vue?vue&type=script&lang=js&"
export * from "./TeacherTrainingModules.vue?vue&type=script&lang=js&"
import style0 from "./TeacherTrainingModules.vue?vue&type=style&index=0&id=9ca32454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca32454",
  null
  
)

export default component.exports